import React, { useRef } from "react";
import emailjs from "@emailjs/browser";

export default function ContactUs() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    const serviceID = "service_nrtl554";
    const templateID = "template_hgv6gkb";
    emailjs
      .sendForm(serviceID, templateID, form.current, {
        publicKey: "Er3G9aJCUc01JFatr",
      })
      .then(
        () => {
          console.log("SUCCESS!");
        },
        (error) => {
          console.log("FAILED...", error.text);
        }
      );
  };
  return (
    <section class="contact section-padding" id="contact">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="sectioner-header text-center">
              <h3>Contáctanos</h3>
              <span class="line"></span>
              <p>Puedes contactarnos por las siguientes vías</p>
            </div>
            <div class="section-content">
              <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-8">
                  <form id="contact_form" ref={form} onSubmit={sendEmail}>
                    <div class="row">
                      <div class="col">
                        <input
                          type="text"
                          id="your_name"
                          class="form-input w-100"
                          name="full-name"
                          placeholder="Nombre completo"
                          required
                        />
                      </div>
                      <div class="col">
                        <input
                          type="email"
                          id="email"
                          class="form-input w-100"
                          name="email"
                          placeholder="Email"
                          required
                        />
                      </div>
                    </div>
                    <input
                      type="text"
                      id="subject"
                      class="form-input w-100"
                      name="subject"
                      placeholder="Nicho de su negocio"
                    />
                    <textarea
                      class="form-input w-100"
                      id="message"
                      placeholder="Qué tiene en mente?"
                      name="message"
                    ></textarea>
                    <button
                      class="btn-grad w-100 text-uppercase"
                      type="submit"
                      name="button"
                    >
                      Enviar
                    </button>
                  </form>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-4">
                  <div class="contact-info white">
                    <div class="contact-item media">
                      <i class="fa fa-map-marker-alt media-left media-right-margin"></i>
                      <div class="media-body">
                        <p class="text-uppercase">Address</p>
                        <p class="text-uppercase">Operamos de manera virtual</p>
                      </div>
                    </div>
                    <div class="contact-item media">
                      <i class="fa fa-mobile media-left media-right-margin"></i>
                      <div class="media-body">
                        <p class="text-uppercase">Phone</p>
                        <p class="text-uppercase">
                          <a
                            class="text-white"
                            href="https://wa.me/+5359596970"
                          >
                            5359596970
                          </a>
                        </p>
                      </div>
                    </div>
                    <div class="contact-item media">
                      <i class="fa fa-envelope media-left media-right-margin"></i>
                      <div class="media-body">
                        <p class="text-uppercase">E-mail</p>
                        <p class="text-uppercase">
                          <a class="text-white" href="hainerjonasg@gmail.com">
                            hainerjonasg@gmail.com
                          </a>
                        </p>
                      </div>
                    </div>
                    <div class="contact-item media">
                      <i class="fa fa-clock media-left media-right-margin"></i>
                      <div class="media-body">
                        <p class="text-uppercase">Horarios</p>
                        <p class="text-uppercase">Lun-Sab 8.00 AM a 6.00 PM.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
